import { SIREN_CONFIG, CONFIG_SETTINGS } from 'config.js';
import { useIntl } from "react-intl";


export const loadSettings = async() => {
  const {formatMessage} = useIntl();

  const userjson = localStorage.getItem(CONFIG_SETTINGS.USER_INFO);

  let user = JSON.parse(userjson);

  if (user == null || user.facility_id == null || user.facility_id.length == 0){
    console.error("Could not find Facility ID. Please Login");
    return;
  }

  console.log("loadSettings..... " + user.facility_id);

  var url = `${SIREN_CONFIG.HOSTNAME}/settings/settings?facility_id=`+user.facility_id;
  const opt = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };


  fetch(url, opt)
    .then(res => res.json())
    .then(responseData => {

      let val = '';

      if (responseData.resultData !== null) {

        console.log("responseData.resultData: " + responseData.resultData);

        responseData.resultData.map(doc => {
          if (doc.settingName === "FirebaseRootRef"){
            val = doc.settingValue;
          }
        });
      }

      console.log("[App] loadSettings: " + val);
      localStorage.setItem(CONFIG_SETTINGS.FIREBASE_ROOT, val);
    })
    .catch(function (err) {
      alert(formatMessage({id:'network_error'}) + `: ${err}`);
      // alert(`Network Errror(${err})가 발생했습니다.`);
    });
}